import type { CustomerSummary } from "@estelle/domain";

import type { Projection } from "@/modules/types";

/**
 * A customer flattened to the field names `CUSTOMER_FIELDS` declares.
 *
 * Computed from the row alone, as every screen's projection is — read the
 * comment at the top of `modules/orders/projections.ts`. Here nothing richer
 * is possible or needed: the server has already joined the orders and the
 * annotations into the summary, so this is a rename, not a lookup.
 *
 * `phone` and `email` come out empty when the row has none *and* when the
 * server did not send them (no `customers.view_contact`) — the screen cannot
 * tell the two apart, which is the point of not sending them.
 */
export function projectCustomer(customer: CustomerSummary): Projection {
  return {
    displayName: customer.displayName,
    phone: customer.phone ?? "",
    email: customer.email ?? "",
    city: customer.city ?? "",
    state: customer.state ?? "",
    ordersCount: customer.ordersCount,
    totalSpent: customer.totalSpent,
    lastOrderAt: customer.lastOrderAt,
    tags: customer.tags,
    note: customer.note?.body ?? "",
  };
}
